import { render, staticRenderFns } from "./index.vue?vue&type=template&id=352b6f56"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=352b6f56&lscoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('352b6f56')) {
      api.createRecord('352b6f56', component.options)
    } else {
      api.reload('352b6f56', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=352b6f56", function () {
      api.rerender('352b6f56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/theme/index.vue"
export default component.exports